"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var congridLinkedProjectsActions = require("@caddigital/sok-reducers/lib/actions/congrid/projects");
var congridProjectsActions = require("@caddigital/sok-reducers/lib/actions/congrid/congridProjects");
var congridLinkActions = require("@caddigital/sok-reducers/lib/actions/congrid/link");
var modalActions = require("@caddigital/sok-reducers/lib/actions/congrid/configModal");
var CongridProjects_1 = require("./CongridProjects");
var Types = require("types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./styles.scss");
var mapStateToProps = function (state) {
    return {
        linkedProjects: state.congrid.projects,
        congridProjects: state.congrid.congridProjects,
        modal: state.congrid.configModal,
        link: state.congrid.link
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchCongridProjects: function (id, token) {
        return dispatch(congridProjectsActions.fetchRequest(id, token));
    },
    fetchLinkedCongridProjects: function (id) {
        return dispatch(congridLinkedProjectsActions.fetchRequest(id));
    },
    toggleModal: function () { return dispatch(modalActions.toggleModal()); },
    toggleCongridLinkedProjectsSelection: function (id) {
        return dispatch(congridLinkedProjectsActions.toggleSelection(id));
    },
    toggleCongridProjectsSelection: function (id) {
        return dispatch(congridProjectsActions.toggleSelection(id));
    },
    linkProjects: function (projectId, apiKey, cps) { return dispatch(congridLinkActions.linkProjectRequest(projectId, apiKey, cps)); },
    unlink: function (projectId) { return function (congridIds) {
        return dispatch(congridLinkActions.unLinkProjectRequest(projectId, [congridIds]));
    }; },
    clear: function () {
        dispatch(congridLinkActions.clear()),
            dispatch(congridProjectsActions.clear()),
            dispatch(congridLinkedProjectsActions.clear()),
            dispatch(modalActions.clear());
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('apiKey', 'setApiKey', ''), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.modal.isOpen && this.props.projectId !== -1) {
            this.props.fetchLinkedCongridProjects(this.props.projectId);
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.modal.isOpen !== prevProps.modal.isOpen) {
            if (this.props.modal.isOpen) {
                this.props.fetchLinkedCongridProjects(this.props.projectId);
            }
            else {
                this.props.clear();
            }
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.modal.isOpen ||
            this.props.modal.isOpen !== nextProps.modal.isOpen) {
            return true;
        }
        return false;
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var addNewConnectionEnhance = recompose_1.pure;
var AddNewConnection = addNewConnectionEnhance(function (props) {
    return (React.createElement("div", { className: 'add-new-connection' },
        React.createElement("h2", { className: 'header' }, (0, translation_1.getLocalization)('congrid-modal/new-connection')),
        React.createElement("label", { htmlFor: 'api-key' }, (0, translation_1.getLocalization)('congrid-modal/api-key')),
        React.createElement(sok_ui_1.TextInput, { id: 'api-key', className: 'white', value: props.apiKey, onChange: function (e) { return props.setApiKey(e.target.value); } }),
        React.createElement(sok_ui_1.Button, { type: 'submit', color: 'green', className: 'connect', onClick: function () {
                return props.fetchCongridProjects(props.projectId, props.apiKey);
            }, text: (0, translation_1.getLocalization)('congrid-modal/btn/connect') })));
});
exports.default = enhance(function (props) {
    return (React.createElement(sok_ui_1.Modal, { className: 'congrid-configuration-modal', isOpen: props.modal.isOpen },
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.link.unlinkStatus, statusList: ['STANDBY', 'UNLINKING', 'SUCCESS', 'FAILED'] },
            (0, translation_1.getLocalization)('congrid-modal/unlinking'),
            (0, translation_1.getLocalization)('congrid-modal/success'),
            (0, translation_1.getLocalization)('congrid-modal/failed')),
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.link.linkProjectStatus, statusList: ['STANDBY', 'SENDING', 'SENDED', 'FAILED'] },
            (0, translation_1.getLocalization)('congrid-modal/linking'),
            (0, translation_1.getLocalization)('congrid-modal/success'),
            (0, translation_1.getLocalization)('congrid-modal/failed')),
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.toggleModal(); } }, (0, translation_1.getLocalization)('congrid-modal/header')),
        React.createElement(sok_ui_1.Container, null,
            React.createElement(sok_ui_1.Grid.Row, { className: 'grid-row' },
                React.createElement(sok_ui_1.Grid.Column, { large: 6 },
                    React.createElement(AddNewConnection, { fetchCongridProjects: props.fetchCongridProjects, projectId: props.projectId, apiKey: props.apiKey, setApiKey: props.setApiKey }),
                    React.createElement("h2", { className: 'header' }, (0, translation_1.getLocalization)('congrid-modal/linked-projects')),
                    React.createElement(CongridProjects_1.CongridProjects, { projects: props.linkedProjects.items, status: props.linkedProjects.status, fetchAgain: function () {
                            return props.fetchLinkedCongridProjects(props.projectId);
                        }, unlink: function (e) { return props.unlink(props.projectId)(e); } })),
                React.createElement(sok_ui_1.Grid.Column, { large: 6 },
                    React.createElement("h2", { className: 'header' }, (0, translation_1.getLocalization)('congrid-modal/projects')),
                    React.createElement(CongridProjects_1.CongridProjects, { projects: props.congridProjects.items, status: props.congridProjects.status, fetchAgain: function () {
                            return props.fetchCongridProjects(props.projectId, props.apiKey);
                        }, toggleSelection: props.toggleCongridProjectsSelection, selected: props.congridProjects.selected })))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: 'green', className: 'link', onClick: function (e) {
                    e.preventDefault();
                    if (props.apiKey === '') {
                        return;
                    }
                    var cps = props.congridProjects.items.filter(function (cp) {
                        return props.congridProjects.selected.includes(cp.congridId);
                    });
                    props.linkProjects(props.projectId, props.apiKey, cps);
                }, disabled: props.congridProjects.selected.length === 0, text: (0, translation_1.getLocalization)('congrid-modal/btn/connect') }),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/project/files/CreateNewFolderModal/newfolder/buttons/cancel'), onClick: function () { return props.toggleModal(); } }))));
});
